
import axios from "axios";
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      filtroAvancado: false,
      filtroCabecalho: false,
      perPage: 100,
      descricao: null,
      id: null,
      registroSelecionadoId: null,
      paginaAtual: 1,
      fields: [
        {
          key: "ID",
          label: 'ID',
          class:'text-right', 
          sortable: true,
          thStyle: { width: "5%" }
        },
        {
          key: "DESCRICAO",
          label: 'Descrição', 
          sortable: true 
        },
        {
          key: "CFOP",
          label: 'CFOP', 
          sortable: true,
          thStyle: { width: "8%" }
        },
        {
          key: "FORMA",
          label: 'Forma Op.', 
          sortable: true,
          thStyle: { width: "10%" }
        },
        {
          key: "OP_TIPO_MOVIMENTACAO",
          label: 'Tipo Mov.', 
          sortable: true,
          thStyle: { width: "8%" }
        },
        {
          key: "OP_MOVIMENTA_ESTOQUE",
          label: 'Estoque', 
          sortable: true,
          thStyle: { width: "10%" }
        },
        {
          key: "OP_GERA_FINANCEIRO",
          label: 'Financeiro', 
          sortable: true,
          thStyle: { width: "10%" }
        },
        {
          key: "OP_DESTINO_OPERACAO",
          label: 'Destino', 
          sortable: true,
          thStyle: { width: "10%" }
        },
        {
          key: "OP_FINALIDADE_EMISSAO",
          label: 'Finalidade', 
          sortable: true,
          thStyle: { width: "10%" }
        },
        {
          key: "GERA_IMPOSTO_ICMS",
          label: 'ICMS', 
          sortable: true,
          thStyle: { width: "5%" }
        },
        {
          key: "actions" ,
          class:'align-middle text-right',
          thStyle: { width: "7%" },
          label: 'Ações' 
        }
      ]
      
  },
  getters: {
    LISTA: state => {return state.lista },
    FIELDS: state => {return state.fields },
    PER_PAGE: state => {return state.perPage },
    FILTRO_AVANCADO: state => {return state.filtroAvancado},
    FILTRO_CABECALHO: state => {return state.filtroCabecalho},
    ID: state => { return state.id},
    DESCRICAO: state => { return state.descricao},
    REGISTRO_SELECIONADO_ID: state => { return state.registroSelecionadoId  },
    PAGINA_ATUAL: state => { return state.paginaAtual  }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
    SET_LISTA: (state, payload) => { state.lista = payload},
    SET_FIELDS: (state, payload) => { state.fields = payload},
    SET_PER_PAGE: (state, payload) => { state.perPage = payload},
    SET_FILTRO_AVANCADO: (state, payload) => {state.filtroAvancado = payload},
    SET_FILTRO_CABECALHO: (state, payload) => {state.filtroCabecalho = payload},
    SET_ID: (state, payload) => {state.id = payload},
    SET_DESCRICAO: (state, payload) => {state.descricao = payload},
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => { state.registroSelecionadoId = payload  },
    SET_PAGINA_ATUAL: (state, payload) => { state.paginaAtual = payload },
    SET_LIMPAR: (state, payload) => {
        state.lista = [],
        state.filtroAvancado = false,
        state.descricao = null,
        state.id = null,
        state.registroSelecionadoId = null,
        state.paginaAtual = 1
    },
    SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
        state.filtroAvancado = false,
        state.descricao = null,
        state.id = null,
        state.paginaAtual = 1
    }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters }, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
            let descricao = getters.DESCRICAO
            let id = getters.ID
            
            // Detecta se DESCRICAO contém apenas números inteiros (código)
            if (descricao && descricao.trim() && /^\d+$/.test(descricao.trim())) {
              // Se for apenas números, usa como ID em vez de descrição
              id = descricao.trim()
              descricao = null
            }
            
            // Monte um objeto com todos os possíveis filtros
            const filtros = {
                id: id,
                descricao: descricao,
                pagina: getters.PAGINA_ATUAL
            }

            axios
                .get('/api/protected/tipoMovimentacao/pesquisar', filtros)
                .then(({ data, status }) => {
                  // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
                  if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                    // Retorna os dados sem comitar, indicando que precisa de confirmação
                    resolve({ 
                      data, 
                      status,
                      needsConfirmation: true,
                      count: data.length
                    });
                    return
                  }
                  
                  // Comita os dados normalmente se não precisar de confirmação
                  commit("SET_LISTA", data)
                  resolve({ data, status })
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/tipo-movimentacao-store.js